import { CustomFields } from '../../models/userdata/customfields';
// import { CustomFieldsMetaData } from '../../models/userdata/customfieldsmetadata';
export class ProtectedInfo{
    public dob: any = '';
    public doNotTriggerEvent : boolean = false;
    public customFields: CustomFields = new CustomFields();
}

// export class CustomFields {
//     public candidateCustomMetaData: CustomFieldsMetaData = new CustomFieldsMetaData();
// }